export default __webpack_public_path__ + "static/media/sambaris.82c5e88b.png";